import { render, staticRenderFns } from "./ExtraAdvantages.vue?vue&type=template&id=423bd25e&scoped=true"
import script from "./ExtraAdvantages.vue?vue&type=script&lang=js"
export * from "./ExtraAdvantages.vue?vue&type=script&lang=js"
import style0 from "./ExtraAdvantages.vue?vue&type=style&index=0&id=423bd25e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423bd25e",
  null
  
)

export default component.exports